export enum StatusType {
    Passive = 0,
    Active = 1,
    Deleted = 2
}